import React, {useState} from 'react';
import {Row} from 'antd';
import {CommentOutlined} from '@ant-design/icons';
import ChatAssistant from "./ChatAssistant";
import {assistantBg, assistantBorder, assistantColor} from "./utils/CustomRobotIcon";


export default function AICard() {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
       <Row justify={"end"}>
    <div
        onClick={() => setIsOpen(true)}
        style={{
            cursor: "pointer",
            border: "1px solid",
            borderColor: assistantBorder,
            padding: "8px 16px",
            borderRadius: 24,
            backgroundColor: assistantBg,
            boxShadow: "0 2px 8px rgba(250, 140, 22, 0.15)",
            transition: "all 0.3s ease",
            display: "flex",
            alignItems: "center",
            gap: 8,
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.backgroundColor = "#fff2e8";
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.backgroundColor = "#fff7e6";
        }}
    >
        <CommentOutlined
            style={{
                color: assistantColor,
                fontSize: 16
            }}
        />
        <span style={{
            color: assistantColor,
            fontWeight: 500,
            fontSize: "14px"
        }}>
            Chat con ERIK
        </span>
    </div>

    {isOpen && <ChatAssistant isOpen={isOpen} setIsOpen={(v) => setIsOpen(v)}/>}
</Row>
    );
}
